import {gql} from '@apollo/client';

export const CATEGORY_QUERY = gql`
    query categoryPage($categoryId: String, $preview: Boolean) {
        categoryCollection(
            where: {sys: {id: $categoryId}}
            preview: $preview
            limit: 1
        ) {
            items {
                sys {
                    id
                    firstPublishedAt
                    publishedAt
                }
                slug
                parentId
                path
                partition
                name
                headline
                introduction
                image {
                    title
                    url
                }
                metaTitle
                metaDescription
                featuredArticlesTitle
                featuredArticlesCollection {
                    items {
                        path
                        slug
                        headline
                        heroFile {
                            url
                            title
                        }
                        overview
                        parent {
                            name
                            path
                        }
                    }
                }
                callOutsCollection {
                    items {
                        __typename
                        ... on Category {
                            title: headline
                            path
                            overview
                            image {
                                title
                                description
                                url
                            }
                        }
                        ... on Article {
                            title: headline
                            path
                            overview
                            image: heroFile {
                                title
                                description
                                url
                            }
                            parent {
                                name
                                path
                            }
                        }
                    }
                }
                externalLinkCarousel {
                    title
                    externalLinksCollection {
                        items {
                            title
                            details
                            link
                            image {
                                title
                                description
                                url
                            }
                        }
                    }
                }
                hreflang
            }
        }
        subcategories: categoryCollection(
            where: {parentId: $categoryId}
            preview: $preview
        ) {
            items {
                path
                name
                overview
                image {
                    title
                    description
                    url
                }
            }
        }
    }
`;
